import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { MailingRecord } from '../../../../shared/models/mailingRecord';
import { MailingRecordService } from '../../../../shared/services/mailingRecord.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StoreLocationService } from '../../../services/storelocation.service';
import { StoreLocation } from '../../../models/storeLocation';
import { Brand } from '../../../models/Brand';
import { BrandService } from '../../../services/brand.service';
import { State, STATES } from '../../../../shared/models/state';
import { CampaignType } from '../../../models/CampaignType';
import { CampaignTypeService } from '../../../services/campaignType.service';
//import { NgbDateStruct, NgbCalendar, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { MatDatepickerModule, MatNativeDateModule, MatChipInputEvent } from '@angular/material';
import { DatePipe, formatDate } from '@angular/common';
import { ValidationService } from '../../../services/validation.service';

@Component({
  selector: 'app-mailing-record-edit-form',
  templateUrl: './mailing-record-edit.component.html',
 
})

export class MailingRecordEditFormComponent implements OnInit { 

  //input/output parameters
  @Input() title;
  @Input() mailingRecord: MailingRecord; 
  editForm: FormGroup; 
  submitted = false;  
  public genderList = ['F', 'M'];
  public storeLocationList: StoreLocation[];
  public brandList: Brand[];
  public stateList: State[] = STATES;  // bind list of states
  public campaignTypeList: CampaignType[];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private mailingRecordService: MailingRecordService,
    private brandService: BrandService,
    private storeLocationService: StoreLocationService,
    private campaignTypeService: CampaignTypeService,
    private notification: MatSnackBar) { }

  // on component load
  ngOnInit() { 
     
    //bind brand dropdown
    this.brandService.getAll().subscribe(brandResult => {
      this.brandList = brandResult; 
    });

    // bind store locations dropdown
    this.storeLocationService.getAll(this.mailingRecord.brandId).subscribe(locationResult => {
      this.storeLocationList = locationResult;
    });

    // bind campaign types
    this.campaignTypeService.getAll().subscribe(campaignResult => {
      this.campaignTypeList = campaignResult;
    });

    const dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;

    this.editForm = this.formBuilder.group({
      id: [this.mailingRecord.id],
      patientId: [this.mailingRecord.patientId],
      clxPatientId: [this.mailingRecord.clxPatientId],
      firstName: [this.mailingRecord.firstName, Validators.required],
      lastName: [this.mailingRecord.lastName, Validators.required],
      address1: [this.mailingRecord.address1, Validators.required],
      address2: [this.mailingRecord.address2 ],
      city: [this.mailingRecord.city, [Validators.required, ValidationService.alphaNumericSpecialCharactersValidator]],
      state: [this.mailingRecord.state, Validators.required],
      zipCode: [this.mailingRecord.zipCode, [Validators.required, ValidationService.zipCodeValidator]],
      gender: [this.mailingRecord.gender, Validators.required],
      //dateOfBirth: [this.mailingRecord.dateOfBirth, Validators.pattern(dateReg)],
      dateOfBirth: [(this.mailingRecord.dateOfBirth !== null ? formatDate(this.mailingRecord.dateOfBirth, 'MM/dd/yyyy', 'en-US') : null), Validators.pattern(dateReg)],
      lastExamDate: [(this.mailingRecord.lastExamDate !== null ? formatDate(this.mailingRecord.lastExamDate, 'MM/dd/yyyy', 'en-US') : null), [Validators.pattern(dateReg)]],
      //lastExamDate: [this.mailingRecord.lastExamDate, Validators.pattern(dateReg)],
      phone: [this.mailingRecord.phone, ValidationService.phoneValidator],
      email: [this.mailingRecord.email, Validators.email],
      brandId: [this.mailingRecord.brandId, Validators.required],
      campaignTypeId: [this.mailingRecord.campaignTypeId, Validators.required],
      storeLocationId: this.mailingRecord.storeLocationId,
      custom1: [this.mailingRecord.custom1],
      custom2: [this.mailingRecord.custom2],
      custom3: [this.mailingRecord.custom3],
      custom4: [this.mailingRecord.custom4],
      custom5: [this.mailingRecord.custom5],
    });
     
  }

  // format date  
  formatDate(e, fieldName: string) {
    if (e.target.value === null) {
      this.editForm.get(fieldName).setValue('', {
        onlyself: true
      })
    }
    else {
      var convertDate = new Date(e.target.value);

      this.editForm.get(fieldName).setValue(convertDate, {
        onlyself: true
      })
    }
  }

  transformDate(dateStr: string): string {
    const dateSendingToServer = new DatePipe('en-US').transform(dateStr, 'dd/MM/yyyy')
    return dateSendingToServer;
  }

  // handle form submit  
  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.editForm.invalid) {
        return; 
      } 
      const model = this.editForm.value as MailingRecord;
      model.brandId = +this.editForm.value['brandId'];
      model.campaignTypeId = +this.editForm.value['campaignTypeId']; 
      model.months = +this.editForm.value['months'];
      model.storeLocationId = +this.editForm.value['storeLocationId'];
      model.dateOfBirth = this.editForm.value['dateOfBirth'];
      model.lastExamDate = this.editForm.value['lastExamDate'];

      this.mailingRecordService.update(+this.mailingRecord.id, model).subscribe(mailingRecord => {       
        //this.eventEmitter.emit(this.editForm.value);
        this.activeModal.close(true);
        this.showNotification(`The entry was successuly updated!`, 'Okay!') 
      }); 
  }

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  } 

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
